<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
           
            <el-form-item label="补遗书名称" class="table-full-row">
                {{form.zbfilename}}
            </el-form-item>

            <el-form-item label="相关标段" class="table-full-row">
                <span v-for="item in formData.bdlist">{{item.bdname}}</span>
            </el-form-item>

            <el-form-item
                v-if="formData.xtdq"
                label="是否变更预算或保证金"
                class="table-full-row">
                    <el-table :data="dataList" border>
                        <el-table-column
                            prop="bdname"
                            label="标段名称"
                            min-width="160">
                        </el-table-column>
                        <el-table-column
                            label="是否变更保证金"
                            min-width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.izbgbzj=='0'">否</span>
                                    <div v-if="scope.row.izbgbzj=='1'">
                                        {{scope.row.bgbzj}}万元 人民币
                                    </div>
                                </template>
                        </el-table-column>
                        <el-table-column
                            label="是否变更预算"
                            min-width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.izbgys=='0'">否</span>
                                    <div v-if="scope.row.izbgys=='1'">
                                        {{scope.row.bgys}}万元 人民币
                                    </div>
                                    
                                </template>
                        </el-table-column>
                    </el-table>
            </el-form-item>

            <el-form-item label="投标文件递交截止时间(开标时间)">
                {{form.kbtime}}:00
            </el-form-item>

            <el-form-item label="投标文件解密截止时间">
                {{form.tbwjjmjzsj}}:00
            </el-form-item>

            <el-form-item label="质疑截止时间">
                {{form.questionendday}}
            </el-form-item>

            <el-form-item label="补遗书澄清内容" class="table-full-row">
                <span v-html="form.dycqcontent"></span>
            </el-form-item>
            <el-form-item 
                class="table-full-row"
                label="是否推送河北省招标投标公共服务平台">
                    <span v-if="form.ishbpsp=='1'">是</span>
                    <span v-if="form.ishbpsp!='1'">否</span>
            </el-form-item>
            <el-form-item label="附件" class="table-full-row">
                <my-upload
                ref="myUpload"
                readonly
                :file-guid="form.qtfj">
                </my-upload>
            </el-form-item>
            <el-form-item label="招标澄清备案表" class="table-full-row" v-if="formData.izsjjt">
                <my-upload
                ref="myUpload"
                readonly
                :file-guid="form.qtfj">
                </my-upload>
            </el-form-item>
            

            <template slot="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [FORM_PAGE_MIXIN],

    data: () => ({
        form:{},
        formData:{},
        processType:'',
        dataList:[],
    }),
    methods: {
        
        
    },
    created() {
        var that = this;
        if(that.getQuery('isXt')=='1'){
            that.processType = 'xingtai/';
        }
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+`cq/bysdetail.json`,that.detailExtra,(data, res) => {
            that.form = data.model
            that.formData = data
            that.dataList.push({ 
                bdname:data.model.bdname,
                bdcode:data.model.bdcode,
                izbgys:data.model.izbgys,
                bgys:data.model.bgys,
                izbgbzj:data.model.izbgbzj,
                bgbzj:data.model.bgbzj
            })
        });
    },
    mounted() {
 
    },
}
</script>

<style scoped lang="scss">

</style>
